import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { SUMMARY_KEY } from './keys';
import { EnrollApi } from 'api';

function useGetResponse(userId: number, enrollId: number, enabled = false) {
  return useAuthQuery(
    getQueryKeys(SUMMARY_KEY).detail(`${enrollId}-${userId}`),
    () => EnrollApi.getEnrollResponse({ enrollId, userId }),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetResponse;
